import {call, put, takeEvery} from "redux-saga/effects";
import Api from '../services/Api'
import * as types from "../constants/ActionTypes";
import {fetchServiceRepairFailure} from "../actions/serviceActions";
import {isoDurationToMinutes} from "../public/journey1/definition/helper";

function* fetchServices() {
  try {
    const services = yield call(function() {
       return Api.get('/dealer/services')
    });
    yield put({type: 'FETCH_SERVICES.SUCCESS', services});
  } catch (error) {
    yield put({type: 'FETCH_SERVICES.FAILURE', error});
  }
}

function* saveServices(params) {
  try {
    const services = yield call(function() {
     return Api.post('/dealer/services', params.body)
    });

    yield put({type: 'SHOW_NOTIFICATION', notification:{message:'save.success'}});
    yield put({type: 'FETCH.DEALER_CONFIGURATION_CHECK.REQUEST'});
    yield put({type: 'SAVE_SERVICES.SUCCESS', services});
  } catch (error) {
    yield put({type: 'SAVE_SERVICES.FAILURE', error});
  }
}

function* fetchServicesRepair(param) {
  try {
    const {dealerId} = param.payload;
    let services = yield call(function() {
     return Api.get(`/d/${dealerId}/services/repair`)
    });
    const estimatedTimeMin = isoDurationToMinutes(services.body.duration)
    const params = {selectedService: {...services.body, id:services.body.name, estimatedTimeMin}};
    yield put({type: 'SAVE.SET_SERVICE', params});
  } catch (error) {
    yield put(fetchServiceRepairFailure(error));
  }
}

export function* watchSaveServices() {
  yield takeEvery('SAVE_SERVICES.REQUEST', saveServices)
}

export function* watchFetchServices() {
  yield takeEvery('FETCH_SERVICES.REQUEST', fetchServices)
}

export function* watchFetchServicesRepair() {
  yield takeEvery(types.FETCH_SERVICE_REPAIR, fetchServicesRepair)
}

